import React, {useEffect, useState} from 'react';
import {VisitRequestDto} from "../../../../../../modules/vms/dto/VisitRequestDto";
import {FormattedMessage, useIntl} from "react-intl";
import {RequestPlaceDto} from "../../../../../../modules/vms/dto/RequestPlaceDto";
import {Badge, Button, Card, CardContent, CardHeader, Grid, IconButton, Stack} from "@mui/material";
import {AreaDto} from "../../../../../../modules/vms/dto/AreaDto";
import FormFieldText from "../../../../../../components/FormFieldText";
import AreaSelectDialog from "../../../../components/AreaSelectDialog";
import FormFieldTime from "../../../../../../components/FormFieldTime";
import dayjs from "dayjs";
import {Formats} from "../../../../../../constants/Formats";
import DateRangeDivider from "../../../../../../components/DateRangeDivider";
import FormFieldDate from "../../../../../../components/FormFieldDate";
import UserSelectDialog from "../../../../../account/components/UserSelectDialog";
import {UserDto} from "../../../../../../modules/account/dto/UserDto";

export type VisitRequestProps = {
    visitRequest: VisitRequestDto;
    messageMap: Map<string, string>;
    onChange: (name: string, value: any) => void;
    onChangeVisitRequest: (record: VisitRequestDto) => void;
};

const VisitRequest: React.FC<VisitRequestProps> = (props) => {
    const intl = useIntl();

    // 场所选择的对话框
    const [areaSelectDialogOpen, setAreaSelectDialogOpen] = useState(false);

    // 选择的场所显示字符串
    const [selectedPlaceStr, setSelectedPlaceStr] = useState('');

    const [openUserSelectDialog, setUserSelectDialog] = useState(false);

    useEffect(() => {
    }, []);

    const handleChange = (name: string, value: any) => {
        props.onChange(name, value);
    };

    const handleSelectAreas = (areas: Array<AreaDto>) => {
        const places = new Array<RequestPlaceDto>();
        for (let area of areas) {
            const place = new RequestPlaceDto(area);
            places.push(place);
        }
        handleChange("places", places);
        const selectedPlaceStr = areas.map((area) => {
            return area.name
        }).join(',')

        setSelectedPlaceStr(selectedPlaceStr);
    }

    const handleSelectHost = (user: UserDto) => {
        const newVisitRequest = {...props.visitRequest};
        newVisitRequest.hostMobile = user.mobile;
        newVisitRequest.hostFullName = user.fullName;
        props.onChangeVisitRequest(newVisitRequest);
    }

    return (
        <Card>
            <UserSelectDialog open={openUserSelectDialog}
                              onSelect={(value) => handleSelectHost(value)}
                              onClose={() => setUserSelectDialog(false)}/>
            <AreaSelectDialog open={areaSelectDialogOpen} onClose={() => setAreaSelectDialogOpen(false)}
                              onOk={handleSelectAreas}/>
            <CardHeader title={intl.formatMessage({id: 'VMS_VISIT_REQUEST_GENERAL_INFO'})}/>
            <CardContent>
                <FormFieldDate label={intl.formatMessage({id: "VMS_VISIT_REQUEST_ARRIVE_DATE"})}
                               required={true} errorText={props.messageMap.get("arriveStartDate")}
                               value={dayjs(props.visitRequest.arriveStartDate, Formats.DATE_SIMPLE)}
                               minDate={dayjs()}
                               onChange={(value) => handleChange("arriveStartDate", value)}/>
                <Stack direction={'row'} spacing={'2'} justifyContent="flex-start" alignItems="center">
                    <FormFieldTime label={intl.formatMessage({id: "VMS_VISIT_REQUEST_ARRIVE_START_TIME"})}
                                   required={true} errorText={props.messageMap.get("arriveStartTime")}
                                   value={dayjs(props.visitRequest.arriveStartTime, Formats.TIME_SIMPLE)}
                                   onChange={(value) => handleChange("arriveStartTime", value)}/>
                    <DateRangeDivider/>
                    <FormFieldTime label={intl.formatMessage({id: "VMS_VISIT_REQUEST_ARRIVE_END_TIME"})}
                                   required={true} errorText={props.messageMap.get("arriveEndTime")}
                                   value={dayjs(props.visitRequest.arriveEndTime, Formats.TIME_SIMPLE)}
                                   onChange={(value) => handleChange("arriveEndTime", value)}/>
                </Stack>
                <FormFieldText label={intl.formatMessage({id: "VMS_VISIT_REQUEST_PURPOSE"})}
                               required={true} errorText={props.messageMap.get("purpose")}
                               value={props.visitRequest.purpose}
                               onChange={(value) => {
                                   handleChange("purpose", value)
                               }}/>
                <FormFieldText label={intl.formatMessage({id: "VMS_VISIT_REQUEST_PLACE"})}
                               disabled={true} required={true} errorText={props.messageMap.get("places")}
                               value={selectedPlaceStr}
                               endAdornment={
                                   <Badge badgeContent={props.visitRequest.places.length} color="secondary"
                                          overlap="rectangular">
                                       <Button color="primary" onClick={() => setAreaSelectDialogOpen(true)}>
                                           <FormattedMessage id="VMS_VISIT_REQUEST_PLACE_SELECT"/>
                                       </Button>
                                   </Badge>}/>
                <FormFieldText label={intl.formatMessage({id: "VMS_VISIT_REQUEST_HOST_NAME"})}
                               disabled={true} required={true} errorText={props.messageMap.get("hostName")}
                               value={props.visitRequest.hostFullName}
                               endAdornment={
                                   <Button color="primary" onClick={() => setUserSelectDialog(true)}>
                                       <FormattedMessage id="VMS_VISIT_REQUEST_HOST_SELECT"/>
                                   </Button>}/>
                <FormFieldText label={intl.formatMessage({id: "VMS_VISIT_REQUEST_HOST_MOBILE"})}
                               disabled={true} required={true} errorText={props.messageMap.get("hostMobile")}
                               value={props.visitRequest.hostMobile}/>
            </CardContent>
        </Card>
    );
};

export default VisitRequest;